import { motion } from 'framer-motion';

interface VoiceWaveformProps {
  isPlaying?: boolean;
  bars?: number;
}

const VoiceWaveform = ({ isPlaying = false, bars = 40 }: VoiceWaveformProps) => {
  return (
    <div className="flex items-center justify-center gap-1 h-20">
      {Array.from({ length: bars }).map((_, i) => (
        <motion.div
          key={i}
          className={`w-1 rounded-full gradient-brand transition-all duration-300 ${
            isPlaying ? 'animate-waveform-pulse' : ''
          }`}
          style={{
            boxShadow: isPlaying ? '0 0 10px hsl(var(--gradient-cyan) / 0.5)' : 'none',
            // Use CSS animation for staggered effect
            animationDelay: isPlaying ? `${i * 0.03}s` : undefined,
            height: isPlaying ? '60%' : '20%'
          }}
          initial={{ height: '20%' }}
          animate={
            isPlaying
              ? { height: '60%' }
              : { height: '20%' }
          }
          transition={{
            duration: 0.2,
            ease: 'easeInOut'
          }}
        />
      ))}
    </div>
  );
};

export default VoiceWaveform;
